import getSplashApiClient from 'lib/SplashApiClient/singleton';

/**
 * Wraps a SplashApiClient with Double Opt-In API actions
 */
export default class DoubleOptInApiClient {
    /**
     * @param {SplashApiClient} apiClient
     */
    constructor(apiClient) {
        this.apiClient = apiClient;
    }

    /**
     * Get double opt-in settings for an organization
     * @param {string|number} orgId - The organization ID
     * @returns {Promise<Object>} The organization's double opt-in settings
     */
    getOrgDoubleOptInSettings(orgId) {
        return this.apiClient.get(`/optin/organizations/${orgId}`);
    }

    /**
     * Save double opt-in settings for an organization
     * @param {string|number} orgId - The organization ID
     * @param {Object} payload - The settings to save
     * @param {boolean} payload.isDoubleOptInEnabled - Whether double opt-in is enabled
     * @param {boolean} payload.allowEventOverride - Whether event-level override is allowed
     * @returns {Promise<Object>} The save response
     */
    saveOrgDoubleOptInSettings(orgId, payload) {
        return this.apiClient.put(`/optin/organizations/${orgId}`, payload);
    }

    /**
     * Get double opt-in settings for an event
     * @param {string|number} eventId - The event ID
     * @returns {Promise<Object>} The event's double opt-in settings
     */
    getEventDoubleOptInSettings(eventId) {
        return this.apiClient.get(`/optin/events/${eventId}`);
    }

    /**
     * Get groups for an organization with number of users and permissions.
     * @param {string|number} orgId - The organization ID
     * @param {string} search - Search term to filter groups by name
     * @param {number} page - Page number for pagination
     * @param {number} limit - Number of items per page
     * @returns {Promise<unknown>}
     */
    getOrgGroups(orgId, search = '', page = 1, limit = 20) {
        const requestParams = { search, page, limit };
        return this.apiClient.get(`/optin/organizations/${orgId}/groups`, requestParams);
    }
}

export const getDoubleOptInApiClient = () => new DoubleOptInApiClient(getSplashApiClient());
